// extracted by extract-css-chunks-webpack-plugin
module.exports = {"textarea":"_3-ADg1","default":"_1E4cuo","fullWidth":"_1lZl96","noResize":"_2ovYxN"};